import { inject, Injectable } from '@angular/core';
import { SessionService } from '../../services';
import { ReDynamicFilters, ReportRequestBodyStrategy, TracingInfo } from '../../interfaces';
import moment from 'moment/moment';
import { dateTransform } from '../../functions/date-transform';

@Injectable({ providedIn: 'root' })
export class RulesUsageRequestBodyStrategy implements ReportRequestBodyStrategy {
  sessionService = inject(SessionService);
  csvLimit = 10000;
  pageLimit = 100;

  buildRequestBody(config: any, tracingInfo: TracingInfo): ReportRequestBodyStrategy {
    const {
      offset = 0,
      limit,
      allFilters,
      formData,
      executionType,
      sorting,
      template,
      exportReportName,
      isSending
    } = config;
    
    let templateName: string | undefined = '';

    const name = template?.template_name;

    if (executionType === 'csv_load') {
      if (!name) {
        templateName = exportReportName;
      } else if (name.includes(exportReportName) || isSending) {
        templateName = name;
      } else {
        templateName = `${exportReportName}_${name}`;
      }
    } else {
      templateName = name;
    }

    const body: any = {
      scopes: [],
      filters: [],
      offset: offset || 0,
      limit:
        executionType === 'csv_load'
          ? this.csvLimit
          : limit === null
          ? this.pageLimit
          : limit,
      order_by: sorting?.field || null,
      order_direction: sorting?.value || null,
      execution_type: executionType,
      columns_to_show: null,
      tracing_info: Object.assign( {
        template_name: templateName || null,
        p_template_id: template ? template.template_id : null,
      }, tracingInfo),
      realm: this.sessionService.sessionData?.realm || '/',
    };

    allFilters.forEach((field: ReDynamicFilters) => {
      const { field_id, field_group, request_type } = field;
      let value;
      value = this.nullUndefinedOrEmpty(formData[field_id]) ? null : formData[field_id];
      if(value !== null) {
        if (field.field_data_type === 'dateRange' && value) {
          const { start, end, alias } = value;
          const isPredefinedPeriod = alias && alias !== 'custom'
          if (start && end || isPredefinedPeriod) {
            let startDate = start;
            let endDate = end;
            if (isPredefinedPeriod) {
              startDate = dateTransform(alias, 'start');
              endDate = dateTransform(alias, 'end');
            }
            value = [
              moment(startDate).format('YYYY-MM-DDTHH:mm:ss'),
              moment(endDate).format('YYYY-MM-DDTHH:mm:ss'),
            ];
          }
        }

        if(field_group === 'general') {
          body[field_id] = value;
        } else {
          body[field_group] = body[field_group] || [];
          body[field_group].push({ id: field_id, value, ...(request_type || {}) });
        }
      }
    });

    return body;
  }

  private nullUndefinedOrEmpty(value: any): any {
    return value === null || value === undefined || value === '';
  }
}
